import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ormCalculations from "../../../hooks/api/calculate";
import ORMfunctions from "../../../hooks/app/general";
import { type RootState } from "../../../store/store";
import {
  setPriceLoading,
  setPriceSuccess,
  setPriceError,
} from "../../../store/orm/userSession";
import { convertCurrency } from "../../../utils/formater";

export function Calcprice({ id }: { id: string }) {
  const dispatch = useDispatch();
  const userSession = useSelector((state: RootState) => state.userSession);

  // Direct access to the price value (string/number or null)
  const price = userSession.prices?.[id];
  const isLoading = userSession.pricesLoading?.[id];

  useEffect(() => {
    if (!id) return;

    // Check if we already handled this ID (value could be 0 or null, so check for key)
    if (
      userSession.prices &&
      Object.prototype.hasOwnProperty.call(userSession.prices, id)
    ) {
      return;
    }

    if (isLoading) return;

    dispatch(setPriceLoading(id));

    ormCalculations
      .calculate(userSession, true, id)
      .then((res) => {
        // The reducer now handles the extraction of total_price_main_rates
        dispatch(setPriceSuccess({ id, data: res }));
      })
      .catch((err) => {
        // console.error(`Calculation failed for ${id}:`, err);
        // dispatch(setPriceError(id));
      });
  }, [id, userSession.prices, isLoading, dispatch]);

  if (isLoading) {
    return (
      <div className="orm-carprice orm-carprice--loading">
        <span className="orm-price__loader"></span>
      </div>
    );
  }

  // If price is null or undefined, we don't render
  if (price === null || price === undefined) return null;

  return (
    <div className="orm-carprice">
      <div className="orm-price__txt__surtitle">
        {ORMfunctions.i18n("cargroup/unitbefore")} {price.unit}{" "}
        {ORMfunctions.i18n("cargroup/unitafter")}
      </div>
      <div className="orm-price__txt">{convertCurrency(price.price)}</div>
    </div>
  );
}

export default Calcprice;
